import { isSavedCalendarType } from "./clubCapabilities";
import { isClubOwner } from "./UserRoles";

export const ACCOUNT_SETUP_STEP = Object.freeze({
  FINISH: 0,
  PLAN: 1,
  FINANCIAL_VENDOR: 2,
});

export const WIZARD_TAB = Object.freeze({
  CLUB_MODEL: 0,
  PLAN: 1,
  FINANCIAL_VENDOR: 2,
  CALENDAR: 3,
  CLUB: 4,
});

export const HOW_YOU_CHARGE_STEP = Object.freeze({
  key: "how-you-charge",
  stepName: "How You Charge",
});

export const LOGIN_INVALID_CREDENTIALS =
  "Invalid username or password. Please try again.";

const SETUP_FLOW_SEGMENTS = new Set([
  "account-setup",
  "account",
  "subscription-platform",
  "subscription-connected",
]);

export function isValidSetupData(data) {
  return Boolean(data && Array.isArray(data.steps));
}

export function apiStepToWizardTab(apiStep) {
  return Number(apiStep) + 1;
}

export function firstIncompleteWizardTab(steps = [], { hasClubModel, calendarType, club } = {}) {
  const modelDone = hasClubModel === true
    || (hasClubModel !== false && isSavedCalendarType(calendarType || club?.calendarType));
  if (!modelDone) {
    return WIZARD_TAB.CLUB_MODEL;
  }
  const ordered = [...steps].sort((a, b) => Number(a.step) - Number(b.step));
  const incomplete = ordered.find((step) => !step.isStepCompleted);
  if (incomplete) {
    return apiStepToWizardTab(incomplete.step);
  }
  return ordered.length ? apiStepToWizardTab(ordered[ordered.length - 1].step) : WIZARD_TAB.PLAN;
}

export function userNeedsAccountSetup(user, selectedClub) {
  if (!isClubOwner(user)) {
    return false;
  }
  if (selectedClub && selectedClub.accountSetupIsCompleted === false) {
    return true;
  }
  if (selectedClub && selectedClub.accountSetupIsCompleted === true) {
    return false;
  }
  return user?.clubs?.some((club) => club.accountSetupIsCompleted === false) === true;
}

export function isSetupFlowPath(pathname = "") {
  return pathname
    .split("/")
    .filter(Boolean)
    .some((segment) => SETUP_FLOW_SEGMENTS.has(segment));
}

export function loginErrorMessage(error) {
  const payload = error?.response?.data;
  return payload?.Message || payload?.detail || LOGIN_INVALID_CREDENTIALS;
}

export function calendarTypePayload(clubId, calendarType) {
  return { clubId, calendarType };
}

export function planSavePayload(clubId, { freePlan = true, calendarType } = {}) {
  return calendarType
    ? { clubId, freePlan, calendarType }
    : { clubId, freePlan };
}

export function planStepPayload(clubId) {
  return {
    clubId,
    stepNumber: ACCOUNT_SETUP_STEP.PLAN,
    accountSetupIsCompleted: false,
  };
}

export function vendorStepPayload(clubId) {
  return { clubId, stepNumber: ACCOUNT_SETUP_STEP.FINANCIAL_VENDOR };
}

export function finishSetupPayload(clubId) {
  return {
    clubId,
    stepNumber: ACCOUNT_SETUP_STEP.FINISH,
    accountSetupIsCompleted: true,
  };
}

export function setupLoadErrorMessage(error) {
  const status = error?.response?.status;
  const payload = error?.response?.data;
  if (status === 404) {
    return payload?.Message || payload?.detail || "Club not found";
  }
  return payload?.Message || payload?.detail || "Unable to load account setup.";
}
